export default "\r\n> [!INFO]\r\n> \r\n> tags:  #🕸️/🟧️\r\n\r\n\r\n### `= this.file.name`\r\n";